/* lv-reviews-box.js: Bewertungen (sections/lv-reviews-box.liquid)
   1. Masonry-Spalten + „Mehr Bewertungen anzeigen“: neue Karten kommen unten an die
      kuerzeste Spalte, bestehende Karten bewegen sich nicht. Jede Karte gibt es genau
      einmal; sind alle sichtbar, verschwindet der Button.
   2. Foto-Grossansicht: Klick auf ein Kundenfoto oeffnet es gross (Escape, X und
      Klick daneben schliessen, Fokus springt zurueck). */
(function () {
  'use strict';

  if (window.lvReviewsBoxLoaded) {
    return;
  }
  window.lvReviewsBoxLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isDesktop() {
    return window.matchMedia ? window.matchMedia('(min-width: 750px)').matches : true;
  }

  function columnCount() {
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      return 3;
    }
    return 2;
  }

  /* ------------------------------------------------------------------ */
  /* 1. Spalten + Nachladen                                              */
  /* ------------------------------------------------------------------ */
  function initBox(box) {
    if (box.dataset.lvRbInit === '1') {
      return;
    }
    var grid = box.querySelector('.lv-rb__grid');
    if (!grid) {
      return;
    }
    box.dataset.lvRbInit = '1';

    var btn = box.querySelector('.lv-rb__more');
    var btnWrap = box.querySelector('.lv-rb__more-wrap');
    var batch = btn ? parseInt(btn.getAttribute('data-batch'), 10) || 4 : 4;
    var initial = parseInt(grid.getAttribute('data-initial'), 10) || 6;
    if (!isDesktop()) {
      initial = parseInt(grid.getAttribute('data-initial-mobile'), 10) || initial;
    }

    /* Jede Karte genau einmal: Pool in Dokumentreihenfolge, doppelte Inhalte raus */
    var seen = {};
    var pool = [];
    Array.prototype.forEach.call(grid.querySelectorAll('.lv-rb__card'), function (card) {
      var key = (card.textContent || '').replace(/\s+/g, ' ').trim();
      if (seen[key]) {
        card.parentNode.removeChild(card);
        return;
      }
      seen[key] = true;
      pool.push(card);
    });
    if (!pool.length) {
      if (btnWrap) {
        btnWrap.hidden = true;
      }
      return;
    }

    pool.forEach(function (card) {
      card.parentNode.removeChild(card);
    });

    var cols = [];
    var ncols = columnCount();
    grid.classList.add('lv-rb__grid--cols');
    for (var i = 0; i < ncols; i++) {
      var col = document.createElement('div');
      col.className = 'lv-rb__col';
      grid.appendChild(col);
      cols.push(col);
    }

    var added = 0;

    function shortestCol() {
      var best = cols[0];
      for (var j = 1; j < cols.length; j++) {
        if (cols[j].offsetHeight < best.offsetHeight) {
          best = cols[j];
        }
      }
      return best;
    }

    function appendOne(animate) {
      if (added >= pool.length) {
        return false;
      }
      var card = pool[added];
      card.hidden = false;
      if (animate) {
        card.classList.add('lv-rb__card--in');
        /* Endzustand sicherstellen, auch wenn der Browser die Animation pausiert */
        window.setTimeout(function () {
          card.classList.remove('lv-rb__card--in');
        }, 700);
      }
      shortestCol().appendChild(card);
      added++;
      return true;
    }

    function syncButton() {
      if (!btnWrap) {
        return;
      }
      var done = added >= pool.length;
      btnWrap.hidden = done;
      btnWrap.style.display = done ? 'none' : 'flex';
    }

    function addCards(count, animate) {
      var before = grid.offsetHeight;
      for (var k = 0; k < count; k++) {
        if (!appendOne(animate)) {
          break;
        }
      }
      syncButton();
      if (!animate) {
        return;
      }
      /* Raster waechst sanft auf die neue Hoehe, bestehende Karten bleiben stehen */
      var after = grid.offsetHeight;
      if (after <= before) {
        return;
      }
      grid.style.overflow = 'hidden';
      grid.style.height = before + 'px';
      grid.getBoundingClientRect();
      grid.style.transition = 'height 0.45s cubic-bezier(0.2, 0.7, 0.2, 1)';
      grid.style.height = after + 'px';
      var cleared = false;
      var clear = function () {
        if (cleared) {
          return;
        }
        cleared = true;
        grid.style.transition = '';
        grid.style.height = '';
        grid.style.overflow = '';
      };
      grid.addEventListener('transitionend', clear, { once: true });
      window.setTimeout(clear, 600);
    }

    addCards(initial, false);

    if (btn) {
      btn.addEventListener('click', function () {
        addCards(batch, !reduceMotion);
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* 2. Foto-Grossansicht                                                */
  /* ------------------------------------------------------------------ */
  var lightbox = null;
  var lbImg = null;
  var lbCaption = null;
  var lbClose = null;
  var lastTrigger = null;

  /* Texte kommen uebersetzt als data-Attribute vom Wurzel-Element .lv-rb, sonst deutscher Rueckfallwert */
  function label(trigger, attr, fallback) {
    var box = trigger && trigger.closest ? trigger.closest('.lv-rb') : null;
    var text = box ? box.getAttribute(attr) : '';
    return text || fallback;
  }

  function buildLightbox(trigger) {
    if (lightbox) {
      return;
    }
    lightbox = document.createElement('div');
    lightbox.className = 'lv-rb-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', label(trigger, 'data-lightbox-label', 'Kundenfoto'));
    lightbox.innerHTML =
      '<button type="button" class="lv-rb-lightbox__close">' +
      '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M3 3l12 12M15 3L3 15"/></svg>' +
      '</button>' +
      '<figure class="lv-rb-lightbox__figure">' +
      '<img class="lv-rb-lightbox__img" alt="">' +
      '<figcaption class="lv-rb-lightbox__caption"></figcaption>' +
      '</figure>';
    document.body.appendChild(lightbox);
    lbImg = lightbox.querySelector('.lv-rb-lightbox__img');
    lbCaption = lightbox.querySelector('.lv-rb-lightbox__caption');
    lbClose = lightbox.querySelector('.lv-rb-lightbox__close');
    lbClose.setAttribute('aria-label', label(trigger, 'data-lightbox-close', 'Foto schließen'));

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.classList.contains('lv-rb-lightbox__figure')) {
        closeLightbox();
      }
    });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        /* Fokus bleibt im Fenster: einziges Bedienelement ist der Schliessen-Knopf */
        event.preventDefault();
        lbClose.focus();
      }
    });
  }

  function onKey(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeLightbox();
    }
  }

  function openLightbox(trigger) {
    buildLightbox(trigger);
    var src = trigger.getAttribute('data-rb-zoom');
    if (!src) {
      return;
    }
    var thumb = trigger.querySelector('img');
    lastTrigger = trigger;
    lbImg.src = src;
    lbImg.alt = thumb ? thumb.alt : '';
    lbCaption.textContent = trigger.getAttribute('data-rb-caption') || '';
    lbCaption.hidden = !lbCaption.textContent;
    lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    lbClose.focus({ preventScroll: true });
  }

  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) {
      return;
    }
    lightbox.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastTrigger) {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('.lv-rb__photo[data-rb-zoom]') : null;
    if (!trigger) {
      return;
    }
    event.preventDefault();
    openLightbox(trigger);
  });

  /* ------------------------------------------------------------------ */
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.lv-rb'), initBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var box = event.target && event.target.querySelector ? event.target.querySelector('.lv-rb') : null;
    if (box) {
      initBox(box);
    }
  });
})();
